import { useState, useEffect } from 'react';
import PostAJobMainContent from '@/components/PostAJobMainContent/PostAJobMainContent';
import { DeviceContext } from '@/utils/context';
import { Seo } from '@/components/Seo';
import { SEO_DATA } from '@/utils/seoConstants/postajob-page';
import useViewport from '@/hooks/useViewport';

const PostAJob = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => {
    setIsLoaded(true);
  }, []);

  const handleResize = () => {
    window.innerWidth <= 768 ? setIsMobile(true) : setIsMobile(false);
  };

  useViewport(handleResize);

  if (!isLoaded) {
    return null;
  }

  return (
    <DeviceContext.Provider value={isMobile}>
      <PostAJobMainContent />
      <Seo {...SEO_DATA} />
    </DeviceContext.Provider>
  );
};

export default PostAJob;
